module.exports = __webpack_public_path__ + "assets/img/product_plus-c@2x.87aa1e92.jpg";